import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import LoadingButton from '@mui/lab/LoadingButton';
import CustomTextInput from 'components/Forms/CustomTextInput';
import LabelRequired from 'components/FormFields/LabelRequired';
import { CustomDialogTitle } from 'pages/Auth/TwoFactor/TowFactorDialog';
import DraggableDialogWrapper from 'components/DraggableDialogWrapper/DraggableDialogWrapper';
import {
  Dialog,
  Box,
  DialogActions,
  Button,
  Grid,
  DialogContent,
  Typography,
} from '@mui/material';
import useDeliveryComConnect from 'components/Dialog/DeliveryCom/useDeliveryComConnect';

const DeliveryComDialog = ({
  open,
  handleClose,
  title,
  providerName,
  providerSRV,
  error,
}) => {
  const { t } = useTranslation();
  const { handleSubmit, loading, formMethods } = useDeliveryComConnect(
    open,
    handleClose,
    providerSRV
  );

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      disableEscapeKeyDown={true}
      onClose={handleClose}
      PaperComponent={DraggableDialogWrapper}
      PaperProps={{
        sx: {
          width: '754px',
          maxWidth: '100%',
          minHeight: '580px',
          background: '#FAFAFA',
          cursor: 'grab',
        },
      }}
    >
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <Box>
            <CustomDialogTitle
              id="customized-dialog-title"
              onClose={handleClose}
            >
              {`${t(title, { name: providerName })}`}
            </CustomDialogTitle>
            <DialogContent sx={{ width: '100%', cursor: 'initial' }} dividers>
              <Box sx={{ height: '415px', mt: 2 }}>
                <Grid spacing={2} container>
                  <Grid item md={12} sm={12} lg={12} sx={{ height: '72px' }}>
                    <CustomTextInput
                      disabled={false}
                      sx={{ width: '100%' }}
                      name="storeId"
                      label={<LabelRequired>{t('Store ID')}</LabelRequired>}
                    />
                  </Grid>
                  <Grid item md={12} sm={12} lg={12} sx={{ height: '72px' }}>
                    <CustomTextInput
                      disabled={false}
                      sx={{ width: '100%' }}
                      name="webUrl"
                      label={t('Web URL')}
                    />
                  </Grid>
                  {error && (
                    <Grid item md={12} sm={12} lg={12} sx={{ height: '72px' }}>
                      <Typography sx={{ color: 'red', mt: 1, mb: 1 }}>
                        {error}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </DialogContent>
          </Box>
          <DialogActions>
            <Box sx={{ margin: '8px 16px' }}>
              <Button
                variant="outlined"
                onClick={handleClose}
                sx={{
                  mr: 1,
                  color: '#626A7A',
                  borderColor: '#626A7A',
                  '&:hover': {
                    color: '#626A7A',
                    borderColor: '#626A7A',
                    background: 'white',
                  },
                }}
              >
                {t('Cancel')}
              </Button>
              <LoadingButton
                loading={loading}
                variant="contained"
                type={'submit'}
                disabled={
                  !formMethods.formState.isDirty ||
                  !formMethods.formState.isValid ||
                  loading
                }
              >
                {t('Connect')}
              </LoadingButton>
            </Box>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default memo(DeliveryComDialog);
